import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { environment } from 'src/environments/environment';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { IWorkScheduleTemplate } from '../models/work-schedule-template.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class WorkScheduleTemplateApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/ScheduleTemplates`;
  }

  constructor(private http: HttpClient) {}

  loadWorkScheduleTemplates(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IWorkScheduleTemplate[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IWorkScheduleTemplate[]>>(this.url, { params });
  }

  loadAllWorkScheduleTemplates(): Observable<IWorkScheduleTemplate[]> {
    const url = `${this.url}/All`;

    let params = new HttpParams();
    params = params.set('DepartmentId', getDepartmentId());

    return this.http.get<IWorkScheduleTemplate[]>(url, { params });
  }

  loadWorkScheduleTemplateById(id: string): Observable<IWorkScheduleTemplate> {
    const url = `${this.url}/${id}`;
    return this.http.get<IWorkScheduleTemplate>(url);
  }

  createWorkScheduleTemplate(
    workScheduleTemplate: IWorkScheduleTemplate
  ): Observable<IWorkScheduleTemplate> {
    return this.http.post<IWorkScheduleTemplate>(this.url, workScheduleTemplate, { headers });
  }

  updateWorkScheduleTemplate(
    workScheduleTemplate: IWorkScheduleTemplate
  ): Observable<IWorkScheduleTemplate> {
    const url = `${this.url}/${workScheduleTemplate.id}`;
    return this.http.put<IWorkScheduleTemplate>(url, workScheduleTemplate, { headers });
  }

  deleteWorkScheduleTemplate(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
